/**
 * Enum of valid reward-kit item keys, mirroring backend's `REWARD_KIT_ITEM_KEYS_ENUM`
 * (reward-claim.js). The 10-item limit is deliberate; extend the backend enum first.
 * @readonly
 */
export const REWARD_KIT_ITEM_KEYS_ENUM = Object.freeze({
  PEN: "PEN",
  CUP: "CUP",
  T_SHIRT: "T_SHIRT",
  BAG: "BAG",
  BOTTLE: "BOTTLE",
  STICKER_PACK: "STICKER_PACK",
  HOODIE: "HOODIE",
  CAP: "CAP",
  DESK_MAT: "DESK_MAT",
  NOTEBOOK: "NOTEBOOK"
});

/**
 * Image types the reward-kit item upload accepts, mirroring backend's
 * `REWARD_KIT_ITEM_IMAGE_MIME_TYPES` (controllers/admin/course.js).
 * @readonly
 */
export const REWARD_KIT_ITEM_IMAGE_MIME_TYPES = Object.freeze([
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif"
]);

/**
 * Converts the Course's `rewardKitMetadata.items` map into the array shape AntD's `Form.List` needs.
 * @param {object} rewardKitItemsMap - Plain object keyed by `REWARD_KIT_ITEM_KEYS_ENUM` values.
 * @returns {Array<{itemKey: string, displayName: string, displayImageUrl: string, rewardCoinThreshold: number}>}
 */
export const convertRewardKitItemsMapToFormList = (rewardKitItemsMap = {}) => {
  return Object.entries(rewardKitItemsMap).map(([itemKey, itemDetails]) => {
    const { displayName, displayImageUrl, rewardCoinThreshold } = itemDetails || {};
    return { itemKey, displayName, displayImageUrl, rewardCoinThreshold };
  });
};

/**
 * Converts the `Form.List` rows back into the `{ itemKey: details }` map the backend expects.
 * Rows without an `itemKey` are dropped.
 * @param {Array<object>} rewardKitItemsList - The `Form.List` field array.
 * @returns {object} Plain object keyed by `REWARD_KIT_ITEM_KEYS_ENUM` values.
 */
export const convertRewardKitItemsFormListToMap = (rewardKitItemsList = []) => {
  return rewardKitItemsList.reduce((rewardKitItemsMapAccumulator, rewardKitItem) => {
    if (rewardKitItem?.itemKey) {
      const { itemKey, ...rewardKitItemDetails } = rewardKitItem;
      rewardKitItemsMapAccumulator[itemKey] = rewardKitItemDetails;
    }
    return rewardKitItemsMapAccumulator;
  }, {});
};
